export default __webpack_public_path__ + "static/media/friends.8407d1fd.svg";